// extracted by mini-css-extract-plugin
export default {"card":"CardMartiller_card__+KtcM","header":"CardMartiller_header__jRl-0","photo":"CardMartiller_photo__KqxFa","name":"CardMartiller_name__Wm4bJ","link":"CardMartiller_link__jOrkf"};